import { BaseQueryFn } from '@reduxjs/toolkit/dist/query'
import axios, { AxiosRequestConfig, AxiosError } from 'axios'
import { BASE_URL, BASE_URL_HEALTH, FOUNDATION_URL, MISC_URL, POSP_URL } from 'Constants'
import { IApiResponse } from 'Models/ResponseModels'
import { store } from '../app/store'

export const getDefaultHeaders = (token?: string) => {
  const tempHeaders = { 'Content-Type': 'application/json', Source: 'Web', Lang: 'EN' }
  if (token) {
    return {
      ...tempHeaders,
      Authorization: `Token ${token}`,
    }
  }
  return tempHeaders
}

export const getFileHeaders = (token: string) => {
  const tempHeaders = { 'Content-Type': 'multipart/form-data', Source: 'Web', Lang: 'EN' }
  if (token) {
    return {
      ...tempHeaders,
      Authorization: `Token ${token}`,
    }
  }
  return tempHeaders
}

export const axiosBaseQuery =
  ({
    baseUrl,
  }: {
    baseUrl: string
  }): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      body?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
      responseType?: AxiosRequestConfig['responseType']
    },
    unknown,
    unknown
  > =>
    async ({ url, method, body, params, headers, responseType }) => {
      const token = store.getState().user.authenticatedUser.authtoken
      try {
        const result = await axios({
          url: baseUrl + url,
          method,
          data: body,
          params,
          headers: headers ?? getDefaultHeaders(token),
          responseType,
        })
        if (result.data.status.toString() !== '200') {
          if (result.data.message) {
            // toast.error(result.data.message)
            console.log(result.data.message)
          }
          throw result.data
        }
        return { data: result.data }
      } catch (axiosError) {
        if (axios.isAxiosError(axiosError)) {
          const err = axiosError as AxiosError
          return {
            error: {
              status: err.response?.status,
              data: err.response?.data || err.message,
            },
          }
        } else {
          const err = axiosError as IApiResponse
          return {
            error: {
              status: err.status,
              data: err.data,
              message: err.message,
            },
          }
        }
      }
    }

const baseUrlQuery = axiosBaseQuery({
  baseUrl: BASE_URL,
})

const baseUrlHealthQuery = axiosBaseQuery({
  baseUrl: BASE_URL_HEALTH,
})

const foundationUrlQuery = axiosBaseQuery({
  baseUrl: FOUNDATION_URL,
})

const miscUrlQueryWrapper = axiosBaseQuery({
  baseUrl: MISC_URL,
})

const pospUrlQuery = axiosBaseQuery({
  baseUrl: POSP_URL,
});

export { baseUrlQuery, foundationUrlQuery, baseUrlHealthQuery, miscUrlQueryWrapper, pospUrlQuery }
